import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_ORGANIZATIONS_KEY } from '_api/queries/organizations/useGetAllOrganizations';

export const DELETE_ORGANIZATION_KEY = 'delete-organization';

export const useDeleteOrganization = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, { orgID: number }>(
    ({ orgID }) => `/organization/${orgID}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_ORGANIZATION_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ORGANIZATIONS_KEY] });
      },
    },
  );
};
